import { filesQuantFormats } from "../../../utils/utils"
import { StaticFileViewer } from "../../molecules/viewers/StaticFileViewer"

export const TacticalSignal = () => {
  const files = [
    {
      title: "Tracking Error",
      folder: "tactical-signals/tracking-error",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Relative Rotation",
      folder: "tactical-signals/rotation-momentum",
      format: filesQuantFormats.HTML,
    },    
    {
      title: "Momentum",
      folder: "tactical-signals/rw-momentum",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Correlations",
      folder: "tactical-signals/rw-correlation",
      format: filesQuantFormats.HTML,
    },    
    {
      title: "Volatility",
      folder: "tactical-signals/rw-volatility",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Hedge Signal",
      folder: "tactical-signals/hedge-signal",
      format: filesQuantFormats.HTML,
    },    
    {
      title: "Factor Analysis",
      folder: "tactical-signals/factor-analysis",
      format: filesQuantFormats.HTML,
    },
    {
      title: "Market Regime",
      folder: "tactical-signals/market-regime",
      format: filesQuantFormats.HTML,
    },    
    {
      title: "Fixed Income",
      folder: "tactical-signals/fixed-income",
      format: filesQuantFormats.HTML,
    },
    {
      title: "US Labour Market",
      folder: "tactical-signals/macro-us-labour-market",
      format: filesQuantFormats.HTML,
    },
  ]

  return <StaticFileViewer files={files} />
}
